import React, { useState, useEffect } from "react";
import {
  Home,
  Filter,
  Calendar,
  MapPin,
  Award,
  Building2
} from "lucide-react";

import { useDispatch, useSelector } from "react-redux";

// THUNKS
import {
  fetchSponsorshipDetail,
  bookSponsorshipSlot
} from "../../../../features/profileSponsorship/sponsorshipThunks";

import {
  fetchStates,
  fetchDistricts,
  fetchBusinessTypes,
  fetchBusinessCategories,
  fetchBusinessServices
} from "../../../../features/master/masterThunks";
import PaymentOptionModal from "../pyment/PaymentOption";
import PaymentQRModal from "../pyment/PaymentQRModal";
import useCashPayment from "../../../../hooks/useCashPayment";
import SlotModal from "./SlotModal";
import useOnlinePayment from "../../../../hooks/useOnlinePayment";
import PaymentSummaryModal from "../pyment/PymentSummary";

import "./SponsorProfile.css";



const SponsorSlots = () => {
  const dispatch = useDispatch();

  // Redux Selectors
  const { details } = useSelector((state) => state.sponsorship);
  const {
    states,
    districts,
    businessTypes,
    businessCategories,
    businessServices
  } = useSelector((state) => state.master);

  // Local State
  const [position, setPosition] = useState("homepage");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const [selectedWeek, setSelectedWeek] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");

  const [businessTypeId, setBusinessTypeId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [serviceId, setServiceId] = useState("");

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [slotModalOpen, setSlotModalOpen] = useState(false);

  // pyment 
const [paymentOpen, setPaymentOpen] = useState(false);
const [bookingData, setBookingData] = useState(null);
const [summaryOpen, setSummaryOpen] = useState(false);
const [selectedSlotData, setSelectedSlotData] = useState(null);
const { startOnlinePayment } = useOnlinePayment();


const {
  startCashPayment,
  cashPaymentData,
  status,
  payment_status,
  closePayment,
} = useCashPayment({ autoReload: false });



  // find the selected businessType object
const selectedTypeObject = businessTypes.find(
  (bt) => bt._id === businessTypeId
);


// debug 
useEffect(() => {
  console.log("PAYMENT STATUS:", status, payment_status);
}, [status, payment_status]);

// check if selectedType = "Service Provider"
const isServiceProvider = selectedTypeObject?.name?.toLowerCase() === "service providers";


  // Mapping for API PageTypes
  const pageTypeMap = {
    homepage: "Home_Page",
    filter: "Filter_Page"
  };

  // ------------------ Dynamic Month/Year ------------------
// ------------------ Dynamic Month/Year (CORRECTED) ------------------
const getUpcomingMonthYearList = () => {
  const today = new Date();
  const list = [];

  for (let i = 0; i < 12; i++) {
    const date = new Date(today.getFullYear(), today.getMonth() + i, 1);

    list.push({
      month: date.toLocaleString("default", { month: "long" }),
      year: date.getFullYear(),
    });
  }

  return list;
};

const upcomingMonthYearList = getUpcomingMonthYearList();

// unique years for year dropdown
const upcomingYears = [...new Set(upcomingMonthYearList.map(m => m.year))];

// months filtered by selected year
const upcomingMonths = upcomingMonthYearList
  .filter(m => String(m.year) === String(year))
  .map(m => m.month);


  // const upcomingMonths = getUpcomingMonths();
  // const upcomingYears = getUpcomingYears();

 useEffect(() => {
  if (upcomingMonthYearList.length) {
    setYear(upcomingMonthYearList[0].year);
    setMonth(upcomingMonthYearList[0].month);
  }

  dispatch(fetchBusinessTypes());
  dispatch(fetchStates("68e8ef76a65b0a7d7ec75a29"));
}, []);


  // ------------------ On State Change → Load Districts ------------------
  useEffect(() => {
    if (stateId) {
      dispatch(fetchDistricts(stateId));
    }
  }, [stateId]);

  // ------------------ On Business Type Change → Load Categories & Services ------------------
useEffect(() => {
  if (!businessTypeId) return;

  const selectedType = businessTypes.find((bt) => bt._id === businessTypeId);
  const isService = selectedType?.name?.toLowerCase().includes("service");

  if (isService) {
    dispatch(fetchBusinessServices(businessTypeId));   // ✅ pass string
    setCategoryId("");
  } else {
    dispatch(fetchBusinessCategories(businessTypeId)); // ✅ pass string
    setServiceId("");
  }
}, [businessTypeId, businessTypes]);

  // ------------------ Fetch Sponsorship Detail ------------------
  useEffect(() => {
    if (month && year) {
      dispatch(
        fetchSponsorshipDetail({
          pageType: pageTypeMap[position],
          stateId,
          districtId,
          businessTypeId,
          businessCategoryId: categoryId,
          businessServiceId: serviceId,
          year,
          month
        })
      );
    }
  }, [
    position,
    month,
    year,
    stateId,
    districtId,
    businessTypeId,
    categoryId,
    serviceId
  ]);

  // ------------------ Booking ------------------
const handleBook = async () => {
  if (!details?.sponsorship?.id) return;

  const result = await dispatch(
    bookSponsorshipSlot({
      sponsorshipId: details.sponsorship.id,
      week: selectedWeek,
      slotNumber: selectedSlot
    })
  );

  if (bookSponsorshipSlot.fulfilled.match(result)) {
    setBookingData(result.payload.data);
    setSelectedSlotData(result.payload.data); // 👈 IMPORTANT
    setSummaryOpen(true);                     // 👈 OPEN SUMMARY
  }
};


const handleProceedToPay = () => {
  setSummaryOpen(false);
  setPaymentOpen(true);
};

const handlePaymentSelect = (method) => {
  if (!bookingData?.bookingId) return;

  // 🔵 CASH PAYMENT (QR)
  if (method === "cash") {
    startCashPayment({
      bookingId: bookingData.bookingId,
      amount: bookingData.totalAmount,
      paymentFor: "sponsorship",
    });

    setPaymentOpen(false);
    return;
  }

  // 🟢 ONLINE PAYMENT (RAZORPAY)
  if (method === "online") {
    setPaymentOpen(false);

    startOnlinePayment({
      bookingId: bookingData.bookingId,
      amount: bookingData.totalAmount,
      paymentFor: "sponsorship",

      onSuccess: () => {
        // optional: show toast / success screen
         // just re-fetch data if needed
  dispatch(fetchSponsorshipDetail({
    pageType: pageTypeMap[position],
    stateId,
    districtId,
    businessTypeId,
    businessCategoryId: categoryId,
    businessServiceId: serviceId,
    year,
    month
  }));
      },

      onFailure: (err) => {
        console.error("Online payment failed:", err);
      },
    });
  }
};






  return (
    <div className="container sponsor-container pt-3">

      {/* ------------------ SELECT POSITION ------------------ */}
      <div className="section-card">
        <p className="section-title mb-2">Select Position</p>

        <div className="row g-2">
          <div className="col-6">
            <button
              className={`option-btn ${position === "homepage" ? "active" : ""}`}
              onClick={() => setPosition("homepage")}
            >
              <Home className="me-2" size={18} /> Homepage
            </button>
          </div>

          <div className="col-6">
            <button
              className={`option-btn ${position === "filter" ? "active" : ""}`}
              onClick={() => setPosition("filter")}
            >
              <Filter className="me-2" size={18} /> Filter Top 50
            </button>
          </div>
        </div>
      </div>

      {/* ------------------ CAMPAIGN MONTH/YEAR ------------------ */}
      <div className="section-card">
        <p className="section-title mb-3">Select Campaign Month</p>

        <div className="row g-3">

          <div className="col-6">
            <div className="d-flex align-items-center border p-2 rounded">
              <Calendar size={20} className="me-2 text-secondary" />
              <select
  className="form-select border-0"
  value={year}
  onChange={(e) => {
    const selectedYear = e.target.value;
    setYear(selectedYear);

    const firstMonthOfYear = upcomingMonthYearList.find(
      (m) => String(m.year) === String(selectedYear)
    );

    if (firstMonthOfYear) {
      setMonth(firstMonthOfYear.month);
    }
  }}>
  {upcomingYears.map((y, i) => (
    <option key={i} value={y}>{y}</option>
  ))}
</select>

            </div>
          </div>

          <div className="col-6">
            <div className="d-flex align-items-center border p-2 rounded">
              <Calendar size={20} className="me-2 text-secondary"/>
              <select
                className="form-select border-0"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              >
                {upcomingMonths.map((m, i) => (
                  <option key={i}>{m}</option>
                ))}
              </select>
            </div>
          </div>

        </div>
      </div>

      {/* ------------------ LOCATION + BUSINESS FILTERS ------------------ */}
      {position === "filter" && (
        <div className="section-card">
          <p className="section-title mb-3">Select Filters</p>

          <div className="row g-3">

            {/* ------- LOCATION ------- */}
            <div className="col-md-6">
              <div className="border rounded p-3">
                <p className="filter-title">Location</p>

                {/* State */}
                <div className="d-flex border p-2 rounded mb-2">
                  <MapPin size={20} className="me-2 text-secondary" />
                  <select
                    className="form-select border-0"
                    value={stateId}
                    onChange={(e) => setStateId(e.target.value)}
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s._id} value={s._id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* District */}
                <div className="d-flex border p-2 rounded">
                  <Building2 size={20} className="me-2 text-secondary" />
                  <select
                    className="form-select border-0"
                    value={districtId}
                    onChange={(e) => setDistrictId(e.target.value)}
                  >
                    <option value="">Select District</option>
                    {districts.map((d) => (
                      <option key={d._id} value={d._id}>
                        {d.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* ------- BUSINESS ------- */}
<div className="col-md-6">
  <div className="border rounded p-3">
    <p className="filter-title">Business Details</p>

    {/* Business Type */}
    <div className="d-flex border p-2 rounded mb-2">
      <Award size={20} className="me-2 text-secondary" />
      <select
        className="form-select border-0"
        value={businessTypeId}
        onChange={(e) => {
          setBusinessTypeId(e.target.value);
          setCategoryId("");
          setServiceId("");
        }}
      >
        <option value="">Business Type</option>
        {businessTypes.map((t) => (
          <option key={t._id} value={t._id}>
            {t.name}
          </option>
        ))}
      </select>
    </div>

    {/* Combined dropdown: Category or Services based on type */}
    <div className="d-flex border p-2 rounded">
      <Filter size={20} className="me-2 text-secondary" />

     <select
  className="form-select border-0"
  value={isServiceProvider ? serviceId : categoryId}
  onChange={(e) =>
    isServiceProvider
      ? setServiceId(e.target.value)
      : setCategoryId(e.target.value)
  }
>
  <option value="">
    {isServiceProvider ? "Select Service" : "Select Category"}
  </option>

  {isServiceProvider
    ? businessServices.map((s) => (
        <option key={s._id} value={s._id}>
          {s.name}
        </option>
      ))
    : businessCategories.map((c) => (
        <option key={c._id} value={c._id}>
          {c.name}
        </option>
      ))}
</select>

    </div>
  </div>
</div>


          </div>
        </div>
      )}

      {/* ------------------ WEEK SELECTION ------------------ */}
      <div className="section-card">
        <p className="section-title mb-2">Select Week Slot</p>

        <div className="row g-2">
          {details?.week?.map((w) => (
            <div className="col-4 col-md-2" key={w.week_no}>
              <div
                className={`week-box-small ${
                  selectedWeek === w.week_no ? "active" : "" 
                }`}
                onClick={() => {
                  setSelectedWeek(w.week_no);
                  setSelectedSlot(null);
                }}
              >
                <p className="fw-bold mb-1">{w.week}</p>

                <span className="text-muted small">
                  {w.slotPrices.filter((s) => !s.isSlotBooked).length} slots open
                </span>

                <br />
                <span className="badge-available">Available</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ------------------ SLOT POSITION ------------------ */}
      {selectedWeek && (
        <div className="section-card">
          <p className="section-title mb-2">Select Slot Position</p>

          <button
            className="option-btn active"
            onClick={() => setSlotModalOpen(true)}
          >
            <Award className="me-2" size={18} />{" "}
            {selectedSlot ? "Change Slot" : "Select Slot Position"}
          </button>

          {selectedSlot && (
            <div className="selected-slot-box p-3 mt-3 rounded">
              <strong>Slot {selectedSlot}</strong>
            </div>
          )}
        </div>
      )}

      {/* ------------------ TERMS & BOOK ------------------ */}
      <div className="footer-section mt-3">
        <div className="d-flex align-items-center mb-2">
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />
          <span className="ms-2 small">I agree to the <a className="text-decoration-underline" href="/terms-and-conditions">Terms & Conditions</a></span>
        </div>

        <button
          disabled={!termsAccepted || !selectedSlot}
          onClick={handleBook}
          className="btn w-100"
          style={{
            background:
              termsAccepted && selectedSlot
                ? "var(--color-primary)"
                : "#ddd",
            color: termsAccepted && selectedSlot ? "#fff" : "#777",
            padding: "12px",
            borderRadius: "12px",
            fontWeight: "600"
          }}
        >
          Book Slot
        </button>
      </div>

      {/* ------------------ SLOT MODAL ------------------ */}
      <SlotModal
        show={slotModalOpen}
        onClose={() => setSlotModalOpen(false)}
        slots={
          details?.week?.find((w) => w.week_no === selectedWeek)?.slotPrices ||
          []
        }
        selectedSlot={selectedSlot}
        setSelectedSlot={setSelectedSlot}
      />
  {/* ------------------ PYMENTOPTINAL MODAL AND PYMENTQRMODAL ------------------ */}
<PaymentSummaryModal
  show={summaryOpen}
  slot={{
    amount: bookingData?.price,
    gstPercentage: bookingData?.gstPercentage,
    gstAmount: bookingData?.gstAmount,
    totalAmount: bookingData?.totalAmount,
    position: selectedSlot,
  }}
  pageNo={selectedWeek}
  onClose={() => setSummaryOpen(false)}
  onBookClick={handleProceedToPay}
/>


  <PaymentOptionModal
  open={paymentOpen}
  onClose={() => setPaymentOpen(false)}
  onSelect={handlePaymentSelect}
/>


<PaymentQRModal
  open={Boolean(cashPaymentData)}
  data={cashPaymentData}
  status={status}
  payment_status={payment_status}
  onClose={closePayment}
/>


    </div>
  );
};

export default SponsorSlots;
